var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRenameIconPrimary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.2085 5.16699H5.16683C4.48169 5.16699 3.82461 5.43916 3.34014 5.92363C2.85567 6.4081 2.5835 7.06518 2.5835 7.75033V25.8337C2.5835 26.5188 2.85567 27.1759 3.34014 27.6604C3.82461 28.1448 4.48169 28.417 5.16683 28.417H23.2502C23.9353 28.417 24.5924 28.1448 25.0769 27.6604C25.5613 27.1759 25.8335 26.5188 25.8335 25.8337V16.792",
    stroke: "#735BF2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.896 3.2293C24.4099 2.71544 25.1068 2.42676 25.8335 2.42676C26.5602 2.42676 27.2571 2.71544 27.771 3.2293C28.2849 3.74315 28.5735 4.44009 28.5735 5.1668C28.5735 5.8935 28.2849 6.59044 27.771 7.1043L15.5002 19.3751L10.3335 20.6668L11.6252 15.5001L23.896 3.2293Z",
    stroke: "#735BF2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenameIconPrimary);
export default __webpack_public_path__ + "static/media/renameIconPrimary.e1a6ed4dfe881651f1dd4815a2f87742.svg";
export { ForwardRef as ReactComponent };